var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.32812 3.66667C1.32812 2.73325 1.32812 2.26654 1.50978 1.91002C1.66957 1.59641 1.92454 1.34144 2.23814 1.18166C2.59466 1 3.06137 1 3.99479 1C4.92821 1 5.39492 1 5.75144 1.18166C6.06505 1.34144 6.32001 1.59641 6.4798 1.91002C6.66146 2.26654 6.66146 2.73325 6.66146 3.66667V10.3333C6.66146 11.2668 6.66146 11.7335 6.4798 12.09C6.32001 12.4036 6.06505 12.6586 5.75144 12.8183C5.39492 13 4.92821 13 3.99479 13C3.06137 13 2.59466 13 2.23814 12.8183C1.92454 12.6586 1.66957 12.4036 1.50978 12.09C1.32812 11.7335 1.32812 11.2668 1.32812 10.3333V3.66667Z",
    stroke: "#DDDDEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99609 10.3333H4.00208",
    stroke: "#DDDDEE",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.32812 3.66669H6.66146",
    stroke: "#DDDDEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62721 4.51228C7.39061 3.62559 7.27231 3.18224 7.35378 2.79733C7.42545 2.45875 7.60202 2.15164 7.85819 1.92003C8.1494 1.65672 8.59091 1.53793 9.47392 1.30034C10.3569 1.06275 10.7984 0.943951 11.1817 1.02577C11.5189 1.09773 11.8247 1.27504 12.0554 1.53227C12.3176 1.82471 12.4359 2.26806 12.6725 3.15476L14.3624 9.48772C14.599 10.3744 14.7173 10.8178 14.6358 11.2027C14.5641 11.5413 14.3876 11.8484 14.1314 12.08C13.8402 12.3433 13.3987 12.4621 12.5157 12.6997C11.6327 12.9373 11.1911 13.056 10.8078 12.9742C10.4707 12.9023 10.1648 12.725 9.93419 12.4677C9.67197 12.1753 9.55367 11.7319 9.31707 10.8452L7.62721 4.51228Z",
    stroke: "#DDDDEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8516 10.1302L11.8573 10.1286",
    stroke: "#DDDDEE",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99609 4.33346L12.3295 3",
    stroke: "#DDDDEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.1eebe966b1c3d0e424efe95f063cf11c.svg";
export { ForwardRef as ReactComponent };